import React, { useEffect, useRef, useState } from "react";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";

function BombaRouletteBonus({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, gameResult, walletBalance, denomination }) {
    const [isSpinning, setIsSpinning] = useState(false);
    const [wheelResult, setWheelResult] = useState(0);
    const [rotation, setRotation] = useState(0);
    const [resultNumber, setResultNumber] = useState(null);
    const wheelRef = useRef(null);

    const bgSoundRef = useRef(null);

    // Bonus open hote hi background sound bajao, close hone par band kar do
    useEffect(() => {
        const bgSound = new Audio("./assets/bomba-roulette-sound.ogg");
        bgSound.loop = true;
        bgSound.play().catch((e) => console.log("Background audio play error", e));
        bgSoundRef.current = bgSound;

        return () => {
            bgSound.pause();
            bgSound.currentTime = 0;
            bgSoundRef.current = null;
        };
    }, []);

    useEffect(() => {
        // Infinite rotation on page load
        const interval = setInterval(() => {
            if (!isSpinning) {
                setRotation((prev) => prev - 15);
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isSpinning]);



    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            if (key === "b") {
                handleBoxClick();
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId]);

    // winning value ko blink karata hai (spin sounds hata diye, sirf visual blink rakha)
    const handleWinningBlink = () => {
        let winningDiv = document.getElementById("bonus2-winning-value");
        if (!winningDiv) return;

        const blinkInterval = setInterval(() => {
            // visibility use karte hain (display:none nahi) taaki box apni jagah chhode na -> layout shake na ho

        }, 1000);
    }

    const rotationStyle = {
        transform: `rotate(${rotation}deg)`,
        transition: isSpinning ? "transform 1s ease-out" : "transform 0.01s linear",
        width: "100%",
        height: "100%",
        position: "relative",
    };

    const handleBoxClick = () => {

        if (isSpinning) return;

        // jogar-btn / wheel click par background sound band kar do
        if (bgSoundRef.current) {
            bgSoundRef.current.pause();
            bgSoundRef.current.currentTime = 0;
        }

        // jogar-btn / wheel click par yeh sound bajao
        const clickSound = new Audio("./assets/strawberries2.mp3");
        clickSound.play().catch((e) => console.log("Audio play error", e));

        setIsSpinning(true);
        let winningNumber;

        const totalPoints = 24;
        const pointAngle = 360 / totalPoints;

        const finalRotation = rotation % 360 - 15;
        const winningIndex = Math.floor((360 - finalRotation) / pointAngle) % totalPoints;
        winningNumber = winningIndex === 0 ? totalPoints : winningIndex;

        setResultNumber(winningNumber);

        const payload = {
            bonusType: "Bonus02Roulette",
            recordId: gameSessionRecordId,
            tileNumber: winningNumber
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let gameTotalWin = gameResult.winnings * winningNumber;
                setWheelResult(gameTotalWin);

                // winning value blink (sound hata diya)
                handleWinningBlink()

                // show winning code
                if (gameTotalWin >= 0) {
                    setTimeout(() => {
                        if (onBonusRoundCompleted) {
                            onBonusRoundCompleted(gameTotalWin);
                        }
                    }, 6000);
                }
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        });
    };


    return (
        <>
            <div className="h-100 w-100 position-relative bomba-roulette-bonus">
                <img className="h-100 w-100" src="assets/img/Roulette/bg.png" alt="" style={{ height: "18vh" }} />
                <div className="contentPosition p-0">
                    <div className="cauldron-content bg-transparent ">
                        <div className="cauldron-inner-content">
                            <div className="text-center position-relative">
                                <img className="w-100 position-relative z-2" src="./assets/img/bomba-strawberries-header-img.png" alt="" />
                                <div className="header-content">
                                    <div className="Arrow-div">
                                        <img className="w-100" src="./assets/img/Roulette/seta.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="bomda-bg h-100 ">
                                <div className=" container-fluid h-100 position-relative">
                                    <h2 className="text-white vw-2-5 position-absolute top-0 start-0 ps-3">Pressione Joga</h2>
                                    <div className="wheel-row">
                                        <div
                                            className="wheel-box position-relative "
                                            onClick={handleBoxClick}
                                            disabled={isSpinning}
                                        >
                                            <div className="wheel" >
                                                <img ref={wheelRef} style={rotationStyle} src="assets/img/Roulette/wheel.png" alt="Wheel" />
                                            </div>
                                        </div>
                                        <div className="wheel-btn-content d-flex align-items-center justify-content-center">
                                            <div className="multiply-bonus-panel text-center">
                                                <div className="multiply-bonus-title">
                                                    <img src="assets/img/maltiplaque-text.png" alt="" />
                                                </div>

                                                <div className="mb-stat-row">
                                                    <span className="mb-label">
                                                        <img src="assets/img/bonus-text.png" alt="" />
                                                    </span>
                                                    <span className="mb-value-box">X {gameResult?.winnings ?? 0}</span>
                                                </div>
                                                <div className="mb-stat-row">
                                                    <span className="mb-label">
                                                        <img src="assets/img/credito-text.png" alt="" />
                                                    </span>
                                                    <span className="mb-value-box">{getFormattedAmountWithDenomination(walletBalance, denomination)}</span>
                                                </div>
                                                <div className="mb-stat-row">
                                                    <span className="mb-label">
                                                        <img src="assets/img/premio-text.png" alt="" />
                                                    </span>
                                                    <span id="bonus2-winning-value" className="mb-value-box">{isSpinning ? wheelResult : (gameResult?.winnings ?? 0)}</span>
                                                </div>
                                                <div className="mb-stat-row">
                                                    <span className="mb-label"></span>
                                                    <div className="text-center mt-2 jogar-btn-wrap">
                                                        <button className="position-relative jogar-btn "
                                                            onClick={handleBoxClick} disabled={isSpinning}>
                                                            <img className="img-fluid img-normal" src="assets/img/jogar-btn-img.png" alt="" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}

export default BombaRouletteBonus;
